import type { TFunction } from 'i18next';

/** 年份選項（新的在前）：今年往前 back 年、往後 ahead 年 */
export const yearOptions = (back: number, ahead = 0) => {
  const year = new Date().getFullYear();
  return Array.from({ length: back + ahead + 1 }, (_, i) => String(year + ahead - i)).map(value => ({ value, label: value }));
};

/** 1～12 月選項（「1 月」「Jan」…） */
export const monthOptions = (t: TFunction) =>
  Array.from({ length: 12 }, (_, i) => String(i + 1)).map(value => ({ value, label: t('pages:payroll.form.monthOption', { month: value }) }));
